module.exports = __webpack_public_path__ + "58da6b1d3ab84c8f56408dfc3fefec4b.png";


//////////////////
// WEBPACK FOOTER
// ./directives/footer/facebook.png
// module id = 258
// module chunks = 0